import React, { useState } from 'react';
import { IonRow, IonCol, IonCard } from '@ionic/react';
import ReactPlayer from 'react-player';
import { FormatText } from './FormatTextComponent/formatText';
import getType from '../../../pages/Menu/GetDataType';
import { getNetworkStatus } from '../../../selectors/selector';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';

interface IAccordion {
  groupData: any;
  dataType: any;
  isNetworkAvailable: boolean;
}
const CardContent: React.FC<IAccordion> = ({
  groupData,
  dataType,
  isNetworkAvailable
}) => {
  const [youtubePlay, setYoutubePlay] = useState(false);
  const videoPlay = () => {
    setYoutubePlay(!youtubePlay);
  };
  let valueDataType = 'text';
  const getDataType = (fieldName: string) => {
    if (dataType && dataType.length) {
      valueDataType = getType(dataType, fieldName);
    } else {
      valueDataType = 'text';
    }

    return valueDataType;
  };

  return (
    <>
      <IonRow data-testid="IonRow-Menu" class="list_row">
        <IonCol size="12" class="list_column">
          <IonRow>
            <IonCol class="list_row_heading">
              <FormatText
                text={groupData.title}
                dataType={getDataType('title')}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol class="list_row_description">
              {groupData.richTextDescription ? (
                <FormatText
                  text={groupData.richTextDescription}
                  dataType={getDataType('richTextDescription')}
                />
              ) : (
                <FormatText
                  text={groupData.description}
                  dataType={getDataType('description')}
                />
              )}
            </IonCol>
          </IonRow>
        </IonCol>
        {groupData.video ? (
          <IonCol>
            {groupData.video.href && isNetworkAvailable ? (
              <IonCard className="react-player-card" onClick={videoPlay}>
                <ReactPlayer
                  width="100%"
                  height="300px"
                  className="react-player"
                  url={groupData.video.href}
                  playing={youtubePlay}
                  controls={true}
                  volume={0.5}
                />
              </IonCard>
            ) : groupData.video.href && !isNetworkAvailable ? (
              <a href={""}>{groupData.video.href}</a>
            ) : null}
          </IonCol>
        ) : null}
      </IonRow>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  isNetworkAvailable: getNetworkStatus()
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(CardContent);
export { CardContent };
